export const BOOKING_STATUS = {
  APPROVED: 1,
  CANCELLED: 3,
  REFUSED: 2,
  USER_CANCELLED: 4,
};

export const BOOKING_STATUS_LABELS = {
  [BOOKING_STATUS.APPROVED]: {
    label: "filter-booking-status-approved",
    value: BOOKING_STATUS.APPROVED,
  },
  [BOOKING_STATUS.CANCELLED]: {
    label: "filter-booking-status-cancelled",
    value: BOOKING_STATUS.CANCELLED,
  },
  [BOOKING_STATUS.USER_CANCELLED]: {
    label: "filter-booking-status-user-cancelled",
    value: BOOKING_STATUS.USER_CANCELLED,
  },
  [BOOKING_STATUS.REFUSED]: {
    label: "filter-booking-status-refused",
    value: BOOKING_STATUS.REFUSED,
  },
};
